<template>
  <h1 v-show="!isIntern" class="mt-12 mt-1">Aufkäufer {{ getUserContactName }}</h1>

  <div v-show="appVersion && !versionMatch" class="alert alert-info mt-4" role="alert">
    Die Version {{ appVersion }} ist verfügbar.<br/>Bitte neu laden:
    <a href="#" @click="reloadPage" style="text-decoration: underline">neue Version laden</a>
  </div>
  <ul
      class="nav" :class="!isIntern && 'mt-0'">
    <li
        v-if="isIntern"
        @click="showQrReader" class="qr">
      QR-Code
      <img src="@/assets/images/icon-qr-code.svg"/>
    </li>
    <router-link
        v-for="navitem in navitems"
        :key="navitem.name"
        :to="{name: navitem.route}">
      <li v-show="isIntern && navitem.name === 'Verladen' || navitem.name !== 'Verladen'">{{ navitem.name }}</li>
    </router-link>
  </ul>
  <ul
      v-if="isAdmin"
      class="nav mt-4">
    <router-link
        v-for="navitem in adminNavitems"
        :key="navitem.name"
        :to="{name: navitem.route}">
      <li>{{ navitem.name }}</li>
    </router-link>
  </ul>

  <div class="row mt-5 align-items-center">
    <div class="col-4">
      <button @click="logout" type="reset" class="mt-0">Abmelden</button>
    </div>
    <div class="col-4 text-right"><a href="#" @click="reloadPage"><small>Version {{ versionNumber }}</small></a></div>
  </div>

  <app-qr-reader v-if="qr"/>
</template>

<script>
import AppQrReader from "@/components/AppQrReader";
export default {
  name: "PageHome",
  components: {
    AppQrReader
  },
  data() {
    return {
      qr: false,
      appVersion: null,
      versionMatch: true,
    }
  },
  computed: {
    navitems() {
      return this.$store.state.nav
    },
    isAdmin() {
      return this.$store.getters.isAdmin
    },
    isIntern() {
      return this.$store.getters.isIntern
    },
    getUserContactName() {
      return this.$store.getters.contactName
    },
    adminNavitems() {
      return this.$store.state.navAdmin
    },
    versionNumber() {
      return process.env.VUE_APP_VERSION;
    },
  },
  async created() {
    await this.$store.dispatch('setAppConf')
    this.appVersion = this.$store.state.appVersion
    this.versionMatch = process.env.VUE_APP_VERSION == this.appVersion;
    console.log('version match: ', this.versionMatch, process.env.VUE_APP_VERSION, this.appVersion);
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
    showQrReader() {
      this.qr = true;
    },
    async logout() {
      await this.$store.dispatch('signOut')
      this.$router.push({name: 'SignIn'})
    }
  }
}
</script>

<style scoped>

</style>